import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { JobService } from '../../../../service/job.service';
import { JobEvaluateComponent } from '../job-detail-foot/job-evaluate/job-evaluate.component';

@Component({
  selector: 'app-history-repair-record-detail',
  templateUrl: './history-repair-record-detail.component.html',
  styleUrls: ['./history-repair-record-detail.component.less']
})
export class HistoryRepairRecordDetailComponent implements OnInit {
  @Input() currentJob: any;
  @Input() code: number;
  listOfAllData = [];
  constructor(
    private jobService: JobService,
    private modal: NzModalRef,
    private modalService: NzModalService,
    ) { }

  async ngOnInit() {
    // tslint:disable-next-line:max-line-length
    const ls = await this.jobService.getUsersByDateAndUserId(new Date().toLocaleDateString(), this.currentJob.repairerNo);
    if (ls == null) {
      this.listOfAllData = [];
    } else {
      this.listOfAllData = ls;
    }
  }
  operaFunction(code) {
    // code 0 关闭 1 受理 2 派发 3 重派 4 转出 5：编辑
    switch (code) {
      case 0: this.modal.destroy();
              break;
      default:
        break;
    }
  }
  linkFunction(codeNum) {
    switch (codeNum) {
      case 7: // 评价详情
        this.modalService.create({
          nzTitle: '工单评价',
          nzContent: JobEvaluateComponent,
          nzStyle: { top: '20px' },
          nzWidth: 450,
          nzComponentParams: {
            currentJob: this.currentJob,
            code: 0, // code 0 工单详情
          },
          nzOnOk: (ev) => {
          },
          nzOnCancel: (ev) => {
          }
        });
        break;
      default:
        break;
      }
  }

}
